import React from 'react'
import '../components/styles/Step.css'
import ScrambleOnScroll from './ScrambleOnScroll'

function Step(props) {
  return (
    <div className='step-container'>

        <p>{props.text}</p>
    </div>
  )
}

export default Step
